import z from "zod";

export const tourDataSchema = z.object({
  storageKey: z.string().optional(),
  autoStart: z
    .string()
    .optional()
    .transform((value) => undefined !== value && "false" !== value),
});

export type TourDataProps = z.infer<typeof tourDataSchema>;
